export const useStoreStreamChapter = defineStore('StoreStreamChapter', {
    state: () => ({
        streamChapter: null,
        disabled: null,
        error: null,
    }),
    actions: {
        async getStreamChapter(idStreamChapter) {
            this.error = null;
            if (this.streamChapter?.id_stream_chapter !== parseInt(idStreamChapter)) {
                this.streamChapter = null;
            }
            ({streamChapter: this.streamChapter, error: this.error} =
                await useEntityStreamChapter().get(idStreamChapter));
        },
        updateStreamChapterField({field, value}) {
            if (this.streamChapter[field] === undefined)
                throw new Error('Attempted to update a stream chapter field which does not exist (' + field + ').');
            this.streamChapter[field] = value;
        },
        async patchStreamChapter() {
            this.error = null;
            this.disabled = true;
            ({error: this.error} = await useEntityStreamChapter().patch(
                this.streamChapter.id_stream_chapter,
                this.streamChapter,
            ));
            this.disabled = false;
            if (this.error) return;
            await this.refresh();
        },
        async deleteStreamChapter() {
            this.error = null;
            ({error: this.error} = await useEntityStreamChapter().remove(this.streamChapter.id_stream_chapter));
            if (this.error) return;
            await navigateTo('/live/' + this.streamChapter.fk_stream_chapter);
        },
        async refresh() {
            if (this.streamChapter?.id_stream_chapter) {
                await this.getStreamChapter(this.streamChapter.id_stream_chapter);
            }
        },
        clearError() {
            this.error = null;
        },
    },
});
